module.exports = __webpack_public_path__ + "media/images/sp/stores/hiroshima/hiroshima_concept_03-fa6d57914023f07bff3cbe45a258b46d.jpg";